module.exports = __webpack_public_path__ + "static/media/martell_token.44d14c2a.png";